import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { API_URL } from './constants'
import axios from 'axios'
Vue.config.productionTip = false

window.axios = axios.create({
	baseURL: API_URL
})

const eventBus = new Vue()
Vue.prototype.$eventBus = eventBus

window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = API_URL
window.axios.interceptors.response.use(
	response => response,
	error => {
		console.log('error main', error)
		if (!window.navigator.onLine) {
			eventBus.$emit('error', true)
			return Promise.reject(error)
		}
		if (!error.config.preventHandling) {
			if (error.status === 401 && router.currentRoute.name !== 'login') {
				eventBus.$emit('show-snackbar', error.message, 'error')
				router.replace({ name: 'login' })
			}
			// else if (error.response.status === 405) {
			// 	return Promise.reject(error)
			// }
			if (router.currentRoute.name !== 'login') {
				eventBus.$emit(
					'show-snackbar',
					error.message ||
					error.title ||
					'An error occurred ',
					'error'
				)
			}
		}
		return Promise.reject(error)
	}
)
if (localStorage.getItem('isAuth')) {
	window.axios.defaults.headers.common['X-Password'] = localStorage.getItem('auth').password || ''
	// const lastRoute = localStorage.getItem('lastRoute')
	// const lastRouteQuery = localStorage.getItem('lastRouteQuery')
	// if (lastRoute && router.currentRoute.path !== lastRoute) {
	// 	console.log('lastRouteQuery', lastRouteQuery)
	// 	router.push(lastRoute)
	// }
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
